<template>
    <div class="rankRewardInner">
        <div class="parentTabIn">
            <ul class="nav nav-tabs" role="tablist">
                <li class="nav-item">
                    <div class="nav-link" :class="{ 'active': activeTab === 'charmTab' }"
                        @click="changeTab('charmTab')" data-toggle="tab" href="#charmTab" role="tab">Charm</div>
                </li>
                <li class="nav-item">
                    <div class="nav-link" :class="{ 'active': activeTab === 'richTab' }" @click="changeTab('richTab')"
                        data-toggle="tab" href="#richTab" role="tab">Rich</div>
                </li>
                <li class="nav-item" style="display: none;">
                    <div class="nav-link" :class="{ 'active': activeTab === 'roomTab' }" @click="changeTab('roomTab')"
                        data-toggle="tab" href="#roomTab" role="tab">Room</div>
                </li>
                <li class="nav-item">
                    <div class="nav-link" :class="{ 'active': activeTab === 'callTab' }" @click="changeTab('callTab')"
                        data-toggle="tab" href="#callTab" role="tab">Call</div>
                </li>
                <li class="nav-item">
                    <div class="nav-link" :class="{ 'active': activeTab === 'agencyTab' }"
                        @click="changeTab('agencyTab')" data-toggle="tab" href="#agencyTab" role="tab">Agency
                    </div>
                </li>
            </ul>
        </div>
        <div class="tab-content">
            <div class="tab-pane" :class="{ 'active': activeTab === 'charmTab' }" id="charmTab" role="tabpanel">
                <div class="tab-contentIn" v-if="isLoaded_WeeklyRewardsCharmTab">
                    <weeklyRankRewardsCharm />
                </div>
            </div>
            <div class="tab-pane" :class="{ 'active': activeTab === 'richTab' }" id="richTab" role="tabpanel">
                <div class="tab-contentIn" v-if="isLoaded_WeeklyRewardsRichTab">
                    <weeklyRankRewardsRich />
                </div>
            </div>
            <div class="tab-pane" :class="{ 'active': activeTab === 'roomTab' }" id="roomTab" role="tabpanel">
                <div class="tab-contentIn" v-if="isLoaded_WeeklyRewardsRoomTab">
                    <weeklyRankRewardsRoom />
                </div>
            </div>
            <div class="tab-pane" :class="{ 'active': activeTab === 'callTab' }" id="callTab" role="tabpanel">
                <div class="tab-contentIn" v-if="isLoaded_WeeklyRewardsCallTab">
                    <weeklyRankRewardsCall />
                </div>
            </div>
            <div class="tab-pane" :class="{ 'active': activeTab === 'agencyTab' }" id="agencyTab" role="tabpanel">
                <div class="tab-contentIn" v-if="isLoaded_WeeklyRewardsAgencyTab">
                    <weeklyRankRewardsAgency />
                </div>
            </div>            
        </div>
    </div>
</template>
<script>
import weeklyRankRewardsCharm from '../RankRewardInfoComponent/weeklyRankRewardsCharm.vue'
import weeklyRankRewardsRich from '../RankRewardInfoComponent/weeklyRankRewardsRich.vue'
import weeklyRankRewardsRoom from '../RankRewardInfoComponent/weeklyRankRewardsRoom.vue'
import weeklyRankRewardsCall from '../RankRewardInfoComponent/weeklyRankRewardsCall.vue'
import weeklyRankRewardsAgency from '../RankRewardInfoComponent/weeklyRankRewardsAgency.vue'
export default {
    name: 'RankRewardInfoComponent',
    props: {
      currentTab: {
        type: String,
        default: 'charmTab'
      }
    },
    components: {
        weeklyRankRewardsCharm,
        weeklyRankRewardsRich,
        weeklyRankRewardsRoom,
        weeklyRankRewardsCall,
        weeklyRankRewardsAgency
    },
    data() {
        return {
            activeTab: this.currentTab,      
            
            isLoaded_WeeklyRewardsCharmTab: false,
            isLoaded_WeeklyRewardsRichTab: false,
            isLoaded_WeeklyRewardsRoomTab: false,
            isLoaded_WeeklyRewardsCallTab: false,
            isLoaded_WeeklyRewardsAgencyTab: false,
        };
    },
    methods: {
        changeTab(tabId) {
            this.activeTab = tabId;
            this.markTabLoaded(tabId);
        },
        markTabLoaded(tabId) {
            if (tabId === 'charmTab') this.isLoaded_WeeklyRewardsCharmTab = true;
            if (tabId === 'richTab') this.isLoaded_WeeklyRewardsRichTab = true;
            if (tabId === 'roomTab') this.isLoaded_WeeklyRewardsRoomTab = true;
            if (tabId === 'callTab') this.isLoaded_WeeklyRewardsCallTab = true;
            if (tabId === 'agencyTab') this.isLoaded_WeeklyRewardsAgencyTab = true;
        }
    },    
    mounted() {
        // this.isLoadedCharmTab = true
        this.markTabLoaded(this.activeTab);
        
    },
    watch: {
      currentTab(newTab) {
        this.activeTab = newTab;

        this.markTabLoaded(newTab);
      }
    },

}
</script>